<template>
  <section class="page-container">
    <div class="flex flex-align-center flex-sb-center">
      <div class="total">
        <div
          v-for="(value,i) in statistics"
          :key="i"
          class="item">
          <span class="num">{{value.val}}</span>
          <span>{{value.name}}</span>
        </div>
      </div>
    </div>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="Ref., Recipient, Phone No., Tracking No."
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>
            </span>
            <div class="flex-sb">
              <div>
                <v-checkbox-group
                  v-model="stts"
                  :list="statusOptions"
                  :isColumn="false"
                  @change="filterData">
                  <template #default="{ item }">
                    <span class="flex">
                      <span
                        class="circle"
                        :class="{
                          'red': item.id == 0,
                          'orange-light': item.id == 1,
                          'yellow-dark': item.id == 2,
                          'blue': item.id == 3,
                          'green': item.id == 4
                        }"></span>
                      <span>{{ item['name'] }}</span>
                    </span>
                  </template>
                </v-checkbox-group>
              </div>
            </div>
          </div>
          <div class="form-item mg-l-50" >
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe')">None</span>            </span>
            <v-checkbox-group
              v-model="effe"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item mg-l-50" >
            <span>
              Campaign Code
              <!--              <span-->
              <!--                class="all"-->
              <!--                @click="handlerSelectAll('campaign_code')">All</span>-->
              <!--              <span-->
              <!--                class="all"-->
              <!--                @click="handlerNoneAll('campaign_code')">None</span>-->
            </span>
            <v-radio-group
              v-model="campaign_code"
              :value-key="'campaign_code'"
              :list="gitCodeList"
              block
              :label-key="'campaign_code'"
              @change="filterData">
            </v-radio-group>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
      >
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="user"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
            <!--            <p class="channel">{{row.source==1?'Web':'AlipayHK'}}</p>-->
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          label="Adjustment Date">
          <template #default="{row}">
            <p>{{ row.adjustment_date.split(" ")[0]}}</p>
            <p>{{ row.adjustment_date.split(" ")[1]}}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="70"
          prop="id"
        >
          <template #default="{ row }">
            <!--            <span class="button-border">{{row.type_language}}</span>-->
            <div
              class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                      >
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        icon="plane" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Insurance Type">
          <template #default="{ row }">
            <div
              class="flex-algin"
            >
              <div
              >
                <span class="span-label">{{row.plan_type_language}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Policy">
          <template #default="{ row }">
            <div
              class="flex-algin"
            >
              <div
                class="showLick"
              >
                <span class="span-label">{{ row.insurer }} {{  80>row.class_id>50?row.product_type:row.plan}}</span>
              </div>
              <p
                v-if="row.pcy_no||row.cvr_nt_no"
                class="phone-text">
                <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
                <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
              </p>
              <span
                v-if="row.order_sn"
                class="phone-text">
                <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          label="Period"
        >
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
              <span
                v-if="row.is_eff_dt_delay && row.stts != 425"
                class="asap">ASAP</span>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="155px"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.stts),
                    'orange': [401, 301].includes(row.stts),
                    'yellow-dark': [410, 501, 701].includes(row.stts),
                    'blue': [420, 505, 705].includes(row.stts),
                    'green': [425, 510, 710].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'blue': [2,16,64,256].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [512].includes(v.id),
                    'gray': [1024, 2048].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getAnnualTravelList,getAnnualTravelCodeList,getAnnualTravelExport} from '@/api/annual-travel'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'

export default {
  name: 'AnnualTravelList',
  components:{
  },
  mixins: [MixinOptions,MinxinFormat],
  data () {
    return {
      search: null,
      date: [],
      stts: [],
      effe: [],
      campaign_code: '',
      codeList: [],
      showUpdate:false,
      isShow:false,
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      statistics:{
        total: {
          name: 'Total Items',
          val: 0
        },
      }
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    statusList(){
      let {hanberg_status} = this.globalOptions||{}
      return hanberg_status||[]
    },
    gitCodeList(){
      let arr = [{id:'',campaign_code: 'All'},...this.codeList]
      return this.codeList
      return arr
    },

    channelList(){
      return [
        {
          id:1,
          name:'Web'
        },
        {
          id:2,
          name:'AlipayHK'
        }
      ]
    },
    needList(){
      return [
        {
          id:'',
          name:'All'
        },
        {
          id:1,
          name:'Yes'
        },
        {
          id:0,
          name:'No'
        },
      ]
    },
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        let {policy={}} =  this.selectFilterData||{}
        Object.keys(policy).forEach(item=>{
          this[item] = policy[item]
        })
        this.setFilterData(policy||{})
        this.network().getList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    }
  },
  async created(){
    await this.network().getAnnualTravelCodeList()
    await this.network().getList()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    handleSelectionChange(val){
      this.selectData =val.reduce((result,item)=>{
        let {id} = item||{}
        result.push(id)
        return result
      },[])
    },
    handleRow(row){
      const { id, class_id, product_id} = row
    },
    handleUpdate(){
      this.isShow = true
    },
    handleAloneUpdate(row){
      let {id} = row
      this.selectData = [id]
      this.isShow = true
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    handleRefresh(){
      this.filterData()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },

    handlerSelectAll(target){
      let origin = ''
      switch(target) {
        case 'stts':
          origin = 'statusOptions'
          break
        case 'effe':
          origin = 'effeOptions'
          break
        case 'source':
          origin = 'channelList'
          break
        case 'campaign_code ':
          origin = 'gitCodeList'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    handlerDown() {
      this.network().getAnnualTravelExport({
        is_export: 1
      })
    },

    network(){
      return {
        getList: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            campaign_code : this.campaign_code,
            page: this.pageConfig.currentPage,
            search: this.search,
            stts:this.stts,
            effe:this.effe,
            source: this.source,
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res = await getAnnualTravelList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else
          {
            const { data } = await getAnnualTravelList(params)
            this.pageConfig.currentPage = data.current_page
            this.pageConfig.total = data.total
            this.tableData = data.data
            this.statistics.total.val = data.total
          }
        },
        getAnnualTravelCodeList: async (params) => {
          const {data} = await getAnnualTravelCodeList(params)
          this.codeList = data
        },
        getAnnualTravelExport: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            campaign_code : this.campaign_code,
            page: this.pageConfig.currentPage,
            search: this.search,
            stts:this.stts,
            effe:this.effe,
            source: this.source,
            ...otherParams
          }
          const {data} = await getAnnualTravelExport(params)
          let {message}=data
          this.$message({
            type: 'success',
            message: 'Loading...'
          })
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    //margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      .num{
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
        padding: 0 10px;
      }
    }
  }
  .filter-top{
    margin-top:30px;
    margin-bottom: 30px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }

      &.red {
        background: #D73A49;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        display: flex;
        .mg-l-50{
          margin-left: 50px;
        }
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 20px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        color: #24292E;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }


}
::v-deep .el-table-column--selection{
  .cell{
    padding-left: 15px!important;
  }
}
.mg-r-8{
  margin-right: 8px;
}
.channel{
  font-size: 12px;
  font-weight: 600;
  color: #586069;
}
.span-status, .span-options {
  display: inline-block;
  padding: 0px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
  border-radius: 100px;
  max-width: 140px;
  word-break:keep-all;
  white-space:nowrap;
  height: 18px;
  min-height: 18px !important;
  .svg-inline--fa {
    margin-right: 5px;
    font-size: 14px;
  }
}
.table-icon{
  &.margin-top-flex{
    margin-top: 5px;
  }
  .icon{
    margin-right: 10px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e1e4e8;
  }
  .backgroud-width{
    background: #fff!important;
    border: 1px solid #e1e4e8;
  }
}
.flex-algin {
  /*display: flex;*/
  /*flex-direction: column;*/
  //justify-content: space-between;
  //font-weight: 500;
  &.time-text{
    font-size: 12px;
  }
  .icon-text{
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: -0.15px;
    color: #24292E;
    margin-left: 15px;
  }
  .phone-text{
    font-size: 12px;
    color: #6A737D;
    .weight-text{
      font-weight: 600;
    }
  }
  &.period-text{
    display: flex;
    flex-direction: column;
    span{
      font-size: 12px;
    }
    .asap{
      font-weight: bold;
      color: black;
      margin-left: 5px;
    }
  }
  p, span {
    min-height: 20px;
  }
  .first-text{
    color: #24292E;
    font-size: 14px;
  }
  .summary{
    font-size: 12px;
    word-break: break-word;
  }
  .status-height{
    height: 23px;
  }
}
</style>
